/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BoothDto } from '../../models/booth-dto';
import { CreateBoothDto } from '../../models/create-booth-dto';

export interface FloorPlanControllerCreateBoothV1$Params {
      body: CreateBoothDto
}

export function floorPlanControllerCreateBoothV1(http: HttpClient, rootUrl: string, params: FloorPlanControllerCreateBoothV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothDto>> {
  const rb = new RequestBuilder(rootUrl, floorPlanControllerCreateBoothV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BoothDto>;
    })
  );
}

floorPlanControllerCreateBoothV1.PATH = '/api/v1/floor-plan/booth';
